import React, { useEffect,  useRef, useState } from "react";
import h5Share from '@/utils/h5Share'
import styled from "styled-components";
import Header from "@/components/Header";
import Clock from "./components/Clock"

import styles from '@/styles'
import Goods from './goods.json';
import GoodsBg from './imgs/goods_bg.png';
// import { useHistory } from 'react-router'

import {GoodsCard2, Line, ComfirmContainer} from './style';
import { Toast } from "antd-mobile";
import Comfirm from './components/Comfirm';
import { jumpTo, userBehaver } from "../../utils";
import Bg2 from './imgs/bg2@2x.png'
import Detention from './components/Detention'
import bwmodel from '@/config/bwmodel'
import bridge from '@/config/JSbridge'
import { connect } from 'react-redux'

import OpenApp from '../../components/OpenApp';
import { getActivityUserInfo } from '@/api/user-new'
import { fetchScreenDetain } from "./api"
export const isStorm = bwmodel.app === 'storm';

const active_id = 135;

const ShopContainer = ({token,userId}) => {
  const [activeVisible, setActiveVisible] = useState(true) // 活动是否进行
  const [goodsList, setGoodsList] = useState([]);
  const [ timeOver, setTimeOver ] = useState(null)
  const bodyContainer = useRef()
  const [skuId, setSkuId] = useState([0,0,0,0,0,0,0,0]);
  const [num, setNum] = useState(0);
  const [cartGoods, setCartGoods] = useState([]);
  const [coupon, setCoupon] = useState(0);
  const [show, setShow] = useState(false);
  const [visible, setVisible] = useState(false);
  const [isVip, setIsVip] = useState(false);
  const [selectGood, setSelectGood] = useState({}); // 选中的商品，将要被移除
  const [isShowTime, setIsShowTime] = useState(false); // 是否显示30天

  // const history = useHistory();
  const childRef = useRef();
  const detentionRef = useRef();
  const clockRef = useRef();

  useEffect(() => {
    document.title = '历史低价，快抄底！'
    h5Share.main({
      title: `「特价秒杀」VIP低至1000元一年！`,
      desc: '限时抄底风云会员，现下单加赠1个月会员+1套周边，活动结束后恢复原价',
      link: process.env.REACT_APP_DEMAND_URL + 'active_135',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo16.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
  }, [])


  const initPage = () => {

    const active135_isVip = localStorage.getItem('active135_isVip')
    if(active135_isVip === "true") {
      setIsVip(JSON.parse(active135_isVip))
      let goodsList = Goods.map((it,index) => {
        it.isBuy = true;
        return it
      })

      setCartGoods(goodsList)
      setGoodsList(goodsList);
    } else {
      setIsVip(false)
      const active135_skuIds = JSON.parse(localStorage.getItem('active135_skuIds'))||[]
      setSkuId(active135_skuIds)

      const active135_goods_list = JSON.parse(localStorage.getItem('active135_goods_list'))||[]
      let num = active135_goods_list.length;

      setCartGoods(active135_goods_list)
      setNum(num)

      let money = 0;
      if(num <= 3) {
        active135_goods_list.forEach((a,index) => money += (a.price - 1000));

        money = money + num - 1;
      }else {
        active135_goods_list.forEach((a,index) => money += a.price );
        money =  money - 3888;
      }
      setCoupon(money);

      let goodsList = Goods.map((it,index) => {

        if(active135_skuIds[index] === 1) {
          it.isBuy = true;
        } else {
          it.isBuy = false;
        }
        return it
      })

      setGoodsList(goodsList);
    }


  }
  useEffect(()=> {
    getData()
  },[])
  let getData = () => {

    userBehaver({
      activeIdKey: "Activity_View",
      conId: `8401`,
      userId: userId,
      active_id: active_id,
      time: new Date()

    });

    getActivityUserInfo(active_id)
      .then(res => {
        // console.log(res.endTime);
        setTimeOver(res.activityState === 2);

        // }
      })
  }


  useEffect(()=> {
    setGoodsList(Goods);
  },[]);

  useEffect(()=> {
    initPage();
    bridge.addRegisterHandler([
      {
        name: 'viewWillAppear',
        callback: (res) => {
          initPage();
          clockRef.current.refresh();
        }
      },
    ])

    setActiveVisible(true);
  },[])


  function handleScroll(e) {
    let footer = document.getElementById('footer');
    if(footer) {
      if(window.scrollY >=20) {
        footer.classList.add('footer-freeclass-block');
      }else {
        footer.classList.remove('footer-freeclass-block');
      }
    }

  }
  useEffect(()=>{
    window.addEventListener('scroll', handleScroll);
    return   window.addEventListener('scroll', null);
}, [])

  useEffect(() => {
    document.title = '历史低价，快抄底！'
    h5Share.main({
      title: `「特价秒杀」VIP低至1000元一年！`,
      desc: '限时抄底风云会员，现下单加赠1个月会员+1套周边，活动结束后恢复原价',
      link: process.env.REACT_APP_DEMAND_URL + 'active_135',
      thumbUrl: 'https://file.wogoo.com/app/logo/logo16.png',
      wxShare:{
        shareData:{
          imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
        }
      },
      shareData:{
        imgUrl: 'https://file.wogoo.com/app/logo/logo6.png'
      }
    })
  }, [])


  function handleAddVip() {
    if(!isStorm) {
      return
    }
    if(!token) {
      return Toast.info('请先登录');
    }

    userBehaver({
      activeIdKey: "Activity_Start",
      // conId: active_id,
      userId: userId,
      // active_id: active_id,
      conId: `${active_id}_add_${3}`,
      con_ext: `${active_id}_add_${3}`,
      // purchaseType: 'add',
      // goods_id: '3',
    });


    setIsVip(true);

    const goodsMap = Goods.map((it,index) => {
      it.isBuy = true;
      return it;
    });

    setNum(Goods.length);
    localStorage.setItem('active135_isVip',JSON.stringify(true));

    const skuIds = [1,1,1,1,1,1,1,1,1,1];
    setSkuId(skuIds);
    localStorage.setItem('active135_isVip',JSON.stringify(true));
    localStorage.setItem('active135_skuIds', JSON.stringify(skuIds) );

    setCartGoods(goodsMap)

    localStorage.setItem('active135_goods_list', JSON.stringify(goodsMap))

    setGoodsList(goodsMap)

  }



  const handleAddGoods = (goods) => {
    if(!isStorm) {
      return  Toast.info('请在市值风云App内参与活动');
    }
    if(!token) {
      return Toast.info('请先登录');
    }
    userBehaver({
      activeIdKey: "Activity_Start",
      // conId: active_id,
      userId: userId,
      // active_id: active_id,
      conId: `${active_id}_add_${goods.id}`,
      // time: new Date(),
      // con_ext: `add_${goods.id}`,
      // purchaseType: 'add',
      // goods_id: goods.id,
    });

    // 已加入购物车，单次购买无法重复
    if(goods.isBuy) {
     return Toast.info('已加入购物车，单次购买无法重复',1)
    }
    if(cartGoods.length === 0) {
      Toast.success('会员与周边1套已加入购物车',1)
    }

    if(cartGoods.length === 3) {
      return  childRef.current.show();
    }

    const goodsMap = goodsList.map((it,index) => {
      if(it.id === goods.id) {
        it.isBuy = true;
        const skuIds = [...skuId];
        skuIds[index] = 1;
        const num = skuIds.reduce(function (a,b) {
          return a + b
        });

        setNum(num);

        localStorage.setItem('active135_goods_num', JSON.stringify(num))

        setSkuId(skuIds);

        localStorage.setItem('active135_skuIds',JSON.stringify(skuIds))

        let cartGoodsList = [...cartGoods];

        const result = cartGoodsList.filter(it => it.id === goods.id)
        if(!result || result.length===0) {
          let money = 0;
          cartGoodsList.push(goods);
          setCartGoods(cartGoodsList);
          // cartGoodsList.forEach(a => money += (a.price - 1000));

          const len = cartGoodsList.length;

          localStorage.setItem('active135_goods_list', JSON.stringify(cartGoodsList))

          if(len <= 3) {
            cartGoodsList.forEach((a,index) => money += (a.price - 1000));
            money = money + len -1;
          }else {
            cartGoodsList.forEach((a,index) => money += a.price );
            money =  money - 3888;
          }
          setCoupon(money);

        }
      }
      return it;
    })

    setGoodsList(goodsMap);


  }


  const handleSelectGood = (goods) => {
    setVisible(true);
    setSelectGood(goods);
  }
  const handleReduceGoods = () => {



    const goods = selectGood;

    if(isVip) {

      userBehaver({
        activeIdKey: "Activity_Start",
        // conId: active_id,
        userId: userId,
        // active_id: active_id,
        conId: `${active_id}_minus_${3}`,
        // con_ext: `minus_${3}`,

      });
      setIsVip(false);
      const skuIds = [0,0,0,0,0,0,0,0,0,0];
      setSkuId(skuIds);

      setCartGoods([])
      setNum(0);
      setShow(false);

      const goodList = Goods.map(it => ({...it, isBuy: false}))
      setGoodsList(goodList)

      localStorage.setItem('active135_isVip', JSON.stringify(false))
      localStorage.setItem('active135_goods_num', JSON.stringify(0))
      localStorage.setItem('active135_skuIds',JSON.stringify(skuIds))
      localStorage.setItem('active135_goods_list', JSON.stringify([]))


    } else {

      userBehaver({
        activeIdKey: "Activity_Start",
        // conId: active_id,
        userId: userId,
        conId: `${active_id}_minus_${goods.id}`,
        // active_id: active_id,
        // time: new Date(),
        // con_ext: `minus_${goods.id}`,
        // purchaseType: 'minus',
        // goods_id: goods.id,
      });
      const goodsMap = goodsList.map((it,index) => {
        if(it.id === goods.id) {
          it.isBuy = false;
          const skuIds = [...skuId];
          skuIds[index] = 0;
          const num = skuIds.reduce(function (a,b) {
            return a + b
          });

          setNum(num);
          setSkuId(skuIds);

          let cartGoodsList = [...cartGoods];
          cartGoodsList = cartGoodsList.filter(it => it.id !== goods.id)
          // if(!cartGoodsList || cartGoodsList.length===0) {
            let money = 0;
            const len = cartGoodsList.length;
            setCartGoods(cartGoodsList);

            localStorage.setItem('active135_isVip', JSON.stringify(false))
            localStorage.setItem('active135_goods_num', JSON.stringify(num))
            localStorage.setItem('active135_skuIds',JSON.stringify(skuIds))
            localStorage.setItem('active135_goods_list', JSON.stringify(cartGoodsList))

            if(len === 0) {
              setShow(false);
            }
            if(len <= 3) {
              cartGoodsList.forEach((a,index) => money += (a.price - 1000));
              money = money - len;
            }else {
              cartGoodsList.forEach((a,index) => money += a.price );

              money =  money - 3888;
            }
            setCoupon(money);

        }
        return it;
      })
      setGoodsList(goodsMap);
    }
  }

  function close () {
    setVisible(false);
  }
  function success() {
    // props.success();
    close();
    handleReduceGoods();

  }
  const handleSettle = () => {
    if(!isStorm) {
      return Toast.info('请在市值风云App内参与活动')
    }
    if(!token) {
      return Toast.info('请先登录');

    }

    try {

      if(isVip) {
        userBehaver({
          activeIdKey: "Activity_Finish",
          conId: `135_3`,
          userId: userId,
          con_ext: '3'
        });
      } else {

        const con_ext = cartGoods.map(it => it.id).join(',');
        userBehaver({
          activeIdKey: "Activity_Finish",
          conId: `${135}_${con_ext}`,
          userId: userId,
          con_ext: con_ext
        });
      }
    } catch(e) {
      console.log(e);
    }



    if(timeOver) {
      return Toast.info('活动已结束');
    }
    if(cartGoods.length < 2) {
      return  Toast.info('2个会员起购，请选择购买的会员',1)
    }
    jumpTo(`/active_135/settle?id=${skuId.join(':')}&vip=${isVip}&showTime=${isShowTime}`);

    // history.push(`/activity/active_135/settle?id=${skuId.join(':')}&vip=${isVip}`)
  }


  const handleSettleVip = () => {

    if(!isStorm) {
      return Toast.info('请在市值风云App内参与活动')
    }
    if(!token) {
      return Toast.info('请先登录');

    }
    if(timeOver) {
      return Toast.info('活动已结束');
    }
    handleAddVip();
    setIsVip(true);

    userBehaver({
      activeIdKey: "Activity_Finish",
      conId: `135`,
      userId: userId,
      con_ext: '3'
    });

    // history.push(`/activity/active_135/settle?id=${skuId.join(':')}&vip=${true}`)
    jumpTo(`/active_135/settle?id=${skuId.join(':')}&vip=${true}&showTime=${isShowTime}`);
  }
  function showTime(bool) {
    setIsShowTime(bool);
  }
  const handleLeftClick = () => {

    // const bool =  showPopMenu && (count===0);


    console.log(`active135_${userId}_isBuy`);

    const isBuy = localStorage.getItem(`active135_${userId}_isBuy`); // 是否已经购买

    console.log(isBuy);

    if(isBuy === "true") {

      bridge.callHandler('nativeEvent', {event: 'close', params: {
        isDelete: false
      }}, () => {})

    } else {

      detentionRef.current.show();

    }
  }


  // 挽留了
  function handleDetain() {

    if(!isShowTime) {
      fetchScreenDetain()
        .then(()=> {
          // props.detain();
          clockRef.current.refresh();
          console.log();
        })
    }

  }

  const activityShare = (callback) => {
    bridge.callHandler('nativeEvent', {
      event: 'shareLink',
      params: {
        title: `「特价秒杀」VIP低至1000元一年！`,
        desc: '限时抄底风云会员，现下单加赠1个月会员+1套周边，活动结束后恢复原价',
        thumbUrl: 'https://file.wogoo.com/app/logo/logo6.png',
        linkUrl: process.env.REACT_APP_DEMAND_URL + 'active_135',
      },
    }, () => {
      // handleUploadTrace('share', 'click');

      callback && callback();
    })
  }


  return <Container style={isStorm ? {} : {paddingTop: 0}} className={activeVisible? '': 'filter'} ref={bodyContainer}>

    <div  className='page-body' >
      {isStorm &&
        <Header
          title="历史低价，快抄底！"
          right={<img onClick={activityShare} src={bwmodel.theme === '0' ? require(`@/img/share.png`):require(`@/img/share_dark.png`)} className="share-img" alt=''/>}
          hideNaviBar
          leftClick={()=> {
            handleLeftClick()
          }}
          bg_color={styles.bg_color2}
        />
      }
      <div className="rules_btn" onClick={
        ()=>jumpTo('/active_135/rules')
      }><span>活</span><span>动</span><span>规</span><span>则</span></div>

      <div
        className="rules_btn"
        style={{top: '180px'}}
        onClick={
          ()=>jumpTo('https://www.wogoo.com/essay/#/?articleId=d2d70d6d67634be893fb2d2500bf16fa&articleType=1')
        }
      ><span>了</span><span>解</span><span>会</span><span>员</span></div>
      <div className="img_box">
        <img style={{marginTop: '-40px'}} src={require(`./imgs/版头@2x.png`)} alt=''/>
      </div>

      <div className="bgBox">

      <Clock showTime={showTime} ref={clockRef}></Clock>

      {
        goodsList.map(it => {
         return <GoodsCard className="">
            <div className="img_box"
               onClick={()=> {
                jumpTo(`storm://app/user/memberInfoDetails?spuId=${it.spu_id}`);
              }}
            >
              <img src={require(`./imgs/${it.img}`)} alt=""></img>
            </div>
            <div className="content"
             onClick={()=> {
              jumpTo(`storm://app/user/memberInfoDetails?spuId=${it.spu_id}`);
            }}
            >
              <div className="title"><span className="name">{it.name}·年会员</span>{isShowTime&&<span className="days">+送30天</span>}</div>
              <div><span className="price1">¥1000</span><span className="price2">单买¥{it.price}</span></div>
            </div>
            <div
              className={it.isBuy ? 'button_box buy': 'button_box'}
              onClick={()=> {
                handleAddGoods(it);
              }}
            >{
                it.isBuy ? <img className="buy" src={require(`./imgs/buyed.png`)} alt="" />
                  : <img src={require(`./imgs/buy1.png`)} alt="" />
              }</div>
          </GoodsCard>
        })
      }
        <img
          className="isAllVip"
          src={require(`./imgs/single.png`)}
          onClick={()=> handleSettleVip()}
          alt=""/>
        {/* <img src={require(`./imgs/光.gif`)} alt=""/> */}
      <GoodsCard className="">
        <div className="img_box"
         onClick={()=> {
          jumpTo(`storm://app/user/memberInfoDetails?spuId=${1}`);
        }}
        >
          <img src={require(`./imgs/goods9.png`)} alt=""></img>
        </div>
        <div className="content"
          onClick={()=> {
            jumpTo(`storm://app/user/memberInfoDetails?spuId=${1}`)
          }}
        >
          <div className="title"><span className="name">打包所有年会员</span>{isShowTime&&<span className="days">+送30天</span>}</div>
          <div className="price2">风云大会员·年会员</div>
          <div><span className="price1">¥3888</span></div>
        </div>
        <div
          className="button_box"
          onClick={()=> {
            handleSettleVip('vip');
          }}
        ><img src={require(`./imgs/buy2.png`)} alt=""></img></div>
      </GoodsCard>

    </div>
    </div>
    <CardFooter>
      {
        show && <div onClick={()=> {
          setShow(false);
        }} className="mask"></div>
      }
  {/* ${isVip? 'bottom':''} */}
      <div className={`goodsList_box ${show? 'show':''}  `}>
        <div className="title1"> { isVip? '已打包所有年会员': `已选${num}个年会员`
          }
          <img
            src={require('./imgs/close@2x.png')}
            onClick={()=> {
              setShow(false);
            }} alt=""/>
        </div>
          <div className="goods_boxs">
          {
           isVip &&  (
           <React.Fragment>
              <GoodsCard2>
                <div className="img_box"

                >
                  <img src={require(`./imgs/${'goods9.png'}`)} alt=""></img>
                </div>
                <div className="content"

                >
                  <div className="title"><span className="name">打包所有会员（风云大会员）</span></div>
                  <div><span className="price1">打包¥3888</span></div>
                </div>
                <div className="button_box"
                  onClick={()=> {
                    handleSelectGood()
                  }}
                ><img src={require(`./imgs/remove.png`)} alt=""></img></div>
              </GoodsCard2>
              <div className="segmentation"> <span className="content">打包购买后包含以下会员&周边1套</span> <span className="line2"></span> </div>
            </React.Fragment>
            )
          }

        {
          cartGoods.map(it => {
            return  <GoodsCard2>
            <div className="img_box"

            >
              <img src={require(`./imgs/${it.img}`)} alt=""></img>
            </div>
            <div className="content"

            >
              <div className="title"><span className="name">{it.name}·年会员</span></div>
              <div><span className="price1">{isVip?'打包后¥0':'活动价¥1000'}</span><span className="price2">单买¥{it.price}</span></div>
            </div>
            {
              !isVip && <div className="button_box"><img onClick={()=> {
                handleSelectGood(it)
              }} src={require(`./imgs/remove.png`)} alt=""></img></div>
            }

          </GoodsCard2>
          })


        }

      {
       isVip && <React.Fragment>

         <GoodsCard2>
         <div className="img_box">
           <img src={require(`./imgs/${'goods12.png'}`)} alt=""></img>
         </div>
         <div className="content"

         >
           <div className="title"><span className="name">易融术·年会员</span></div>
           <div><span className="price1">打包赠送</span></div>
         </div>
       </GoodsCard2>
       <GoodsCard2>
         <div className="img_box">
           <img src={require(`./imgs/${'goods13.png'}`)} alt=""></img>
         </div>
         <div className="content"

         >
           <div className="title"><span className="name">估值挖掘机·年会员</span></div>
           <div><span className="price1">打包赠送</span></div>
         </div>
       </GoodsCard2>
       <GoodsCard2>
          <div className="img_box"

          >
            <img src={require(`./imgs/${'goods10.png'}`)} alt=""></img>
          </div>
          <div className="content"

          >
            <div className="title"><span className="name">锦鲤卡·年会员</span></div>
            <div><span className="price1">打包赠送</span></div>
          </div>
        </GoodsCard2>
       </React.Fragment>
      }
        <Line />
        <GoodsCard2>
            <div className="img_box"

            >
              <img src={require(`./imgs/${'goods11.png'}`)} alt=""></img>
            </div>
            <div className="content"

            >
              <div className="title"><span className="name">大鳄周边1套</span></div>
              <div><span className="price2">免费赠送（数量有限）</span></div>
            </div>
          </GoodsCard2>
      </div>

      </div>

        { show ? <div className="bg">现在购买所购会员天数都为 {isShowTime?<span className="money">402天</span>: <span className="money">372天</span> }</div>:
        !isVip && <React.Fragment>
          { num === 0 && <div className="bg">买就再<span className="money">送周边1套</span>，送完为止（不足100件）</div> }
          { num === 1 && <div className="bg"><span className="money">再选1个</span>，任选2个会员可享<span className="money">2个1999元</span></div> }
          { num === 2 && <div className="bg">已享2个1999元，<span className="money">再选1个</span>可享<span className="money">3个2998元</span></div>}
          { num === 3 && <div className="bg">已享3个2998元，再加<span className="money">890元打包所有会员</span><span className="btn2"
              onClick={()=> handleAddVip()}
            >加890</span></div>
          }
        </React.Fragment>
      }

      <div className="submitBar">
       <div className="shop_cart"
          onClick={()=> {
            if(!isStorm) {

              return Toast.info('请在市值风云App内参与活动')
            }
            if(!token) {
              return Toast.info('请先登录');

            }
            if(cartGoods.length === 0 && !isVip) {
              return Toast.info('购物车空空如也，去抢购吧');
            }
            if(cartGoods.length > 0 || isVip) {
              setShow(true);
            }

          }}
        >
          <div className="icon">
            <img src={require('./imgs/gouwucheman@2x.png')}  alt=""/>
          </div>
            购物车
            {isVip ? <div className="num">打包</div> : num >0 && <div className="num">{num}</div> }
           {/* {} */}
        </div>
        <div className="foot-content">
          <div>
            合计:<span className="unit"> ¥</span><span className="price">

              {
                isVip && '3888'
              }
              {
                !isVip && (cartGoods.length === 0 ? 0: cartGoods.length <= 3 ? (cartGoods.length * 999 + 1): 3888)
              }

              {/* {cartGoods.length } */}


              {/* {
                isVip ? '3888' : cartGoods.length === 0 ? 0: cartGoods.length <= 3 ? (cartGoods.length * 999 + 1): 3888
              } */}
              </span>
          </div>
          {
            isVip ?  <div className="coupon">立省6316</div> : cartGoods.length > 0 &&  <div className="coupon">
            立省{
              coupon
            }
            </div>
          }
        </div>
        <div className="btn"
          onClick={()=> {

            handleSettle()
          }}
        >
          结算
        </div>
      </div>
    </CardFooter>
    <Comfirm success={()=>handleAddVip()} ref={childRef}></Comfirm>


    <ComfirmContainer  className={visible?'':'hide'}>
      <div className='bg1'>
        <div className='content'>
          <div className='title'> {isVip?'确定移除所有会员吗？':'确定移除该会员吗？'}</div>
          {
            isVip && <div className='tips'>
            移除后购物车将被清空
          </div>
          }
          <div className='footer'>
            <img onClick={()=>close()} src={require('./imgs/再想想@2x.png')} alt=""/>
            <div className="succss" onClick={()=> success()}>确认</div>
            {/* <img } src={require('./imgs/确认打包@2x.png')} alt=""/> */}
          </div>
        </div>

        <div className='close' onClick={()=>close()} >
          <img src={require('./imgs/close@2x.png')} alt=""/>
        </div>
      </div>
    </ComfirmContainer>
    <Detention  detain={()=>handleDetain()} ref={detentionRef}/>

    {
        !isStorm &&
        <div>
          <OpenApp  bottom='bottom' url={`${process.env.REACT_APP_DEMAND_URL}active_135`}></OpenApp>
        </div>
       }
  </Container>;
}


const mapStateToProps = (state) => ({
  token: state.user.accessToken || '',
  userId: state.user.userId || '',
});

export default React.memo(connect(mapStateToProps)(ShopContainer))
// export default React.memo(ShopContainer)


const Container = styled.div`
  position: relative;
  background: #FF7589;
  padding-bottom: 120px;
  .rules_btn {
    position: absolute;
    z-index:100;
    right: 0;
    top: 100px;
    width: 18px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 11px;
    color: #FFFFFF;
    background-image: url(${Bg2});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border: 6px solid transparent;
    border-right: none;
  }
  .isAllVip {
    position: fixed;
    right: 5px;
    bottom: 120px;
    width: 80px;
    z-index: 100;
  }
  img {
    user-select: none;
  }
  .bgBox {
    width: 100%;
    background: linear-gradient(180deg, rgba(255,255,255,20%) 1%, #FF6A7E 99%);
    border-radius: 30px 30px 0px 0px;
    // border-image: linear-gradient(180deg, #FFFFFF, #FF6A7E) 10 10;
    background-size: 100% 517px;
    background-repeat: no-repeat;
    z-index: 1;
    position: relative;
    top: -31vw;
    overflow: hidden;
    
  }
  .share-img {
    width: 20px;
    width: 20px;
    vertical-align: middle;
  }
  .img_box {
    min-width: 80px;
    img{
      font-size:0px;
      vertical-align: middle;
      width: 100%;
    }
  }

  .segmentation {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;
    color: #717171;
    text-align: center;
    width:100%;
    position: relative;
    height: 20px;
    padding:0 14px;
    margin: 10px 0;
    box-sizing: border-box;
    .content {
      position: absolute;
      left: 50%;
      top: 4px;
      display: inline-block;
      background-color:#F1F1F1;
      white-space: nowrap;
      padding:0 20px;
      transform: translateX(-50%);
      
    }
    .line2 {
      border-top: 1px solid #727272 !important;
      display: inline-block;
      width: 100%;
  
    }
  }
`;


const GoodsCard = styled.div`
  margin: 12px;
  height: 88px;
  overflow: hidden;
  padding: 0px 7px;
  border-radius: 10px;
  background-image: url(${GoodsBg});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  .img_box {
    width: 73px;
    height: 73px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .button_box {
    width: 76px;
    height: 76px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      display: block;
      position: relative;
      
    }
    &.buy::after {
        content:'1';
        display: block;
        color: #FFFFFF;
        width: 26px;
        height: 26px;
        position: absolute;
        right: -4px;
        top: -4px;
        font-size: 14px;
        font-weight: bold;
        border: 1px solid #FFFFFF;
        text-align: center;
        line-height: 26px;
        background:#C41825;
        z-index: 100;
        border-radius: 50%;
      }
  }
  .content {
    flex: 1;
    padding-left:6px;
    letter-spacing: -1px;
  }
  .title {
    .name {
      font-family: Alibaba PuHuiTi;
      font-weight: 800;
      font-size: 15px;
      color: #000000;
      line-height: 28px;
    }
    .days {
      color: #FF3E53;
      font-weight: 800;
    }
  }
  .price1 {
    // font-family: Arial Black !important;
    font-family:system-ui !important;
    font-weight: 700;
    font-size: 20px;
    color: #FF3E54;
    line-height: 29px;
    font-style: italic;
    font-weight: bolder;
  }
  .price2 {
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 12px;
    color: #6E6E6E;
    line-height: 26px;
    margin-left:4px;
  }
`;

const CardFooter = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 10;
  .bg {
    font-family: Alibaba PuHuiTi;
     background: rgba(0,0,0,0.7);
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 18px;
    padding: 12px 10px 19px;
    position: relative;
    top: 10px;
    z-index:10;
    text-align: center;
    .money {
      color: #FFA200;
    }
    .btn2 {
      background: linear-gradient(148deg, #FF3061, #FF6C00);
      border-radius: 8px;
      height: 18px;
      display: inline-block;
      line-height:18px;
      padding : 0 8px;
    }
  }
  .submitBar {
    position: relative;
    z-index: 20;
    padding: 14px 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: #FFFFFF;
    border-radius: 10px 10px 0px 0px;
    .icon {
      img {
        width: 35px;
      }
    
  }
  .shop_cart {
    position: relative;
    padding-right: 35px;
    border-right: 1px solid #ccc;
    color: #333;
    .num {
      position: absolute;
      right: 20px;
      top: -3px;
      display: inline-block;
      background-color: #C41825;
      min-width: 26px;
      height: 26px;
      box-sizing: border-box;
      line-height: 26px;
      text-align: center;
      padding: 0 5px;
      color: #FFF;
      font-size: 16px;
      border-radius:13px;
      border: 1px solid #fff;
      font-size: 12px;
    }
  }

  .foot-content {
    flex: 1;
    padding-left: 30px;
    font-weight: bold;
    font-size: 18px;
    color: #222222;
    .unit {
      font-weight: bold;
      font-size: 17px;
      color: #FF3E4C;
    }
    .price {
      font-weight: bold;
      color: #FF3E4C;
      font-size: 30px;
    }
    .coupon {
      color: #FF3E4C;
      font-size: 13px;
    }
  }
  .btn {
    width: 94px;
    height: 44px;
    background: linear-gradient(148deg, #FF3061, #FF9000);
    border-radius: 22px;
    text-align: center;
    align-items: center;
    line-height: 44px;
    font-family: Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }
}
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .goodsList_box {
    background: #F1F1F1;
    border-radius: 15px 15px 0 0;
    overflow: hidden;
    padding-top: 15px;
    position: absolute;
    bottom: 120px;
    z-index: 10;
    width: 100%;
   
    overflow: scroll;
    transition: all 0.2s ease-in;
    transform: translateY(calc(100% + 40px));
    .goods_boxs {
      height: 370px;
      overflow: scroll;
    }
    .title1 {
      display: inline-block;
      width: 100%;
      position: relative;
      text-align: center;
      color: #2C2C2C;
      font-size: 18px;
      img {
        position: absolute;
        width: 21px;
        height: 20px;
        right: 13px;
        top: 0px;
      }
    }
    &.show{
     transform: translateY(0%);
 
    }
    &.bottom {
       bottom: 80px;
    }
  }
 
`




// WEBPACK FOOTER //
// ./src/views/activity_135/index.js